import type {ConcreteEntityType} from 'types';
import {useSchema} from './useSchema';
import {useSchemaReference} from './useSchemaReference';

export const useEntitySchema = (entity: ConcreteEntityType) => {
  const ref = useSchemaReference(entity);
  return useSchema(ref);
};
